/**
 * A suspended tenant (phase 7b): the cloud answers every request of its users
 * `suspended` (HTTP 423) with the vendor's reason. The layout shows that
 * reason on a page of its own instead of the app (`TenantSuspended`).
 */
import { ApiError } from '@norna/api-client/client.js';

/** The server's message when `error` is the `suspended` refusal, else null. */
export function suspendedMessage(error: unknown): string | null {
  if (!(error instanceof ApiError) || error.code !== 'suspended') return null;
  // ApiError's message is `<code> (HTTP <status>): <server message>[issues]`; the page shows the server's part.
  const prefix = `suspended (HTTP ${String(error.status)}): `;
  return error.message.startsWith(prefix) ? error.message.slice(prefix.length) : error.message;
}
